import Cookies from 'js-cookie';
import { create } from 'zustand';
import { IProfile } from '../types';

interface AuthStore {
  isAuth: boolean;
  setAuth: (auth: boolean) => void;
  logout: () => void;
  profile: IProfile | null;
  setProfile: (profile: IProfile) => void;
}

const useAuthStore = create<AuthStore>((set) => ({
  isAuth: !!Cookies.get('_token'),
  profile: Cookies.get('_profile') ? (JSON.parse(Cookies.get('_profile') as string) as unknown as IProfile) : null,
  setAuth: (auth: boolean) => set(() => ({ isAuth: auth })),
  setProfile: (profile: IProfile) => set(() => ({ profile })),
  logout: () =>
    set(() => {
      Cookies.remove('_token');
      Cookies.remove('_profile');

      return { isAuth: false, profile: null };
    }),
}));

export default useAuthStore;
